import { $host } from "../index";

export const confrimResetPassAPI = async ( email: string, password: string, otpCode: string, emailCode: string) => {
    const { data } = await $host.post('/api/auth/credentials/reset', { email, password, otpCode, emailCode })
    return data;
}